import type { ErrorRegistryShape } from '../common/common.error';

export const MEMBER_ERROR = {
  NOT_FOUND_LP: { status: 404, message: 'LP not found' },
  /** 로그인 아이디는 D3 회원 · LP 계정 · 포트폴리오 계정을 통틀어 하나 */
  CONFLICT_USERNAME_DUPLICATE: { status: 409, message: 'Username already in use' },
  /** 자기 자신 · 관리자 계정은 비활성화할 수 없다, 자기 관리자 여부는 바꿀 수 없다 */
  FORBIDDEN_MEMBER_SELF_OR_ADMIN: { status: 403, message: 'Cannot change this member' },
  /** 관리자로 등록(isAdmin=true)하는 것은 관리자만 할 수 있다 */
  FORBIDDEN_MEMBER_ADMIN_GRANT: { status: 403, message: 'Only admins can register an admin' },
  /** 직책(position)은 D3 회원만 가진다 — LP · 포트폴리오 회원은 내 정보에서 바꿀 수 없다 */
  FORBIDDEN_MEMBER_POSITION_D3_ONLY: { status: 403, message: 'Position is for D3 members only' },
  /** 내 담당 포트폴리오(managedPortfolios)는 D3 회원만 정한다 */
  FORBIDDEN_MEMBER_MANAGED_PORTFOLIOS_D3_ONLY: {
    status: 403,
    message: 'Managed portfolios are for D3 members only',
  },
  /** 현재 비밀번호가 맞지 않는다 */
  BAD_REQUEST_CURRENT_PASSWORD: { status: 400, message: 'Current password is incorrect' },
} as const satisfies ErrorRegistryShape;
